// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tw-card{border-radius:8px;margin-block:30px}.tw-card-title{padding-block:10px}.my-account-profile-image .upload-dropzone.image-dropzone{flex-direction:column}@media (max-width: 767.98px){.tw-card-row.edit-password-form-row{flex-direction:column !important;align-items:center !important}.tw-card-row.edit-password-form-row .tw-card-col{flex:unset !important}}\n", ""]);
// Exports
module.exports = exports;
